import React, { useEffect, useState } from 'react';

import ReactTable from '../components/ReactTable';
import { useCommentCols } from '../hooks/EmployeeCols';
import fetchFromAthena from '../functions/FetchFromAthena'

export default function EmployeeComments(props) {
    const commentCols = useCommentCols();
    const [state,setState] = useState({
        data: [],
        isLoading: true
    })

    useEffect(() => {
        getComments()
    },[props.empId, props.company])

    const getComments = async() => {
        const queries = ['employee_comments']

      const data = await Promise.allSettled(
        queries.map(query =>
          fetchFromAthena({
            queryName: query,
            headers: {
              company: props.company,
              empId: props.empId
            },
            accessToken: props.credentials.user.accessToken,
            credentials: props.credentials
          })
        )
      ).then(results => {
        return results
      })
      
      setState({
        isLoading: false,
        data: data[0].value
      })
    }
      return <ReactTable isLoading={state.isLoading} cols={commentCols} data={state.data} />;
}
